import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/facebookPixel";

export const useFacebookPixel = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      const pathname = location.pathname;

      const trackedRoutes = ["/register", "/signin"];
      if (trackedRoutes.includes(pathname)) {
        trackPageView();
      }
    } catch (error) {
      console.error("Error tracking page view:", error);
    }
  }, [location.pathname]);
};
